export default {
    "lc300": {
        img: "lc300",
        desc: "",
        name: "[RL] Karin",
        model: "Grand Cruiser 300",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "370z": {
        img: "Karin",
        desc: "",
        name: "[RL] Annis",
        model: "370X",
        seats: 2,
        acceleration: 6.1,
        maxSpeed: 0,
        fuel: 100
    },
    "g55": {
        img: "g55",
        desc: "",
        name: "[RL] Benefactor-ASG",
        model: "E-Series M463",
        seats: 4,
        acceleration: 6.4,
        maxSpeed: 0,
        fuel: 100
    },
    "ff12": {
        img: "ff12",
        desc: "",
        name: "[RL] Grotti",
        model: "F21 Verleenetta",
        seats: 2,
        acceleration: 6.1,
        maxSpeed: 0,
        fuel: 100
    },
    "f150": {
        img: "f150",
        desc: "",
        name: "[RL] Vapid",
        model: "P-150 Predator",
        seats: 4,
        acceleration: 6.5,
        maxSpeed: 0,
        fuel: 100
    },
    "rrphantom": {
        img: "rrphantom",
        desc: "",
        name: "[RL] Enus",
        model: "Phantasm VIII",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "rs5": {
        img: "370z",
        desc: "",
        name: "[RL] Obey",
        model: "PS5",
        seats: 2,
        acceleration: 6.2,
        maxSpeed: 0,
        fuel: 100
    },
    "rs6": {
        img: "rs6",
        desc: "",
        name: "[RL] Obey",
        model: "PS6",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "rs7": {
        img: "rs7",
        desc: "",
        name: "[RL] Obey",
        model: "PS7",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "evo9": {
        img: "evo9",
        desc: "",
        name: "[RL] Maibatsu",
        model: "Lance Revolution IX",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "evo10": {
        img: "evo10",
        desc: "",
        name: "[RL] Maibatsu",
        model: "Lance Revolution X",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "rx7": {
        img: "rx7",
        desc: "",
        name: "[RL] Annis",
        model: "PX-7",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "etron": {
        img: "etron",
        desc: "",
        name: "[RL] Obey",
        model: "I-Tron GS",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "s600": {
        img: "s600",
        desc: "",
        name: "[RL] Benefactor",
        model: "S-Series M140",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "eclass3": {
        img: "eclass3",
        desc: "",
        name: "[RL] Benefactor",
        model: "E-Series M214",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "sclass3": {
        img: "sclass3",
        desc: "",
        name: "[RL] Benefactor",
        model: "S-Series M223",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "r820": {
        img: "r820",
        desc: "",
        name: "[RL] Obey",
        model: "P8",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "gemera": {
        img: "gemera",
        desc: "",
        name: "[RL] Entity",
        model: "Genera",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "s15": {
        img: "s15",
        desc: "",
        name: "[RL] Annis",
        model: "Slivia",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "lex570": {
        img: "lex570",
        desc: "",
        name: "[RL] Emperor",
        model: "MX 570",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "m4comp": {
        img: "m4comp",
        desc: "",
        name: "[RL] Ubermacht",
        model: "W4 J82 Contention",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "lc200": {
        img: "lc200",
        desc: "",
        name: "[RL] Karin",
        model: "Grand Cruiser 200",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "m5e60": {
        img: "m5e60",
        desc: "",
        name: "[RL] Ubermacht",
        model: "W5 A60",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "m7g70": {
        img: "m7g70",
        desc: "",
        name: "[RL] Ubermacht",
        model: "7-line J70",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "m850": {
        img: "m850",
        desc: "",
        name: "[RL] Ubermacht",
        model: "8-line",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "mark2": {
        img: "mark2",
        desc: "",
        name: "[RL] Karin",
        model: "Marco",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "jesko20": {
        img: "jesko20",
        desc: "",
        name: "[RL] Entity",
        model: "Gesko",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "imola": {
        img: "imola",
        desc: "",
        name: "[RL] Pegassi",
        model: "Emola",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "models": {
        img: "models",
        desc: "",
        name: "[RL] Coil",
        model: "Line S",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "modelx": {
        img: "modelx",
        desc: "",
        name: "[RL] Coil",
        model: "Line X",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "i8": {
        img: "i8",
        desc: "",
        name: "[RL] Ubermacht",
        model: "I8",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "gt63s": {
        img: "gt63s",
        desc: "",
        name: "[RL] Benefactor-ASG",
        model: "ASG GS 4-door",
        seats: 4,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
    "gsx1000": {
        img: "gsx1000",
        desc: "",
        name: "[RL] Shitzu",
        model: "CSX-R 1000",
        seats: 2,
        acceleration: 6.3,
        maxSpeed: 0,
        fuel: 100
    },
};